import './UpdateLead.css'

import { sourceOptions, provinceOptions } from '../../utilities/services/formOptions';

import { useState } from 'react';
import { formNotificationStyle2 } from '../../utilities/services/formNotification';
import { updateLead } from '../../utilities/api/leads';
import { capitalizeFirstLetter } from '../../utilities/services/capitalizeFirstLetter';


const leadStatusOptions = [
  'active', 
  'dead', 
  'hot', 
]

export default function UpdateLead({user, leadItem, getLeads, toggleNotifications}) {
  const defaultState = {
    leadName: leadItem.leadName,
    email: leadItem.email,
    source: leadItem.source,
    contactName: leadItem.contactName,
    phone: leadItem.phone,
    province: leadItem.province,
    canada: leadItem.canada,
    address: leadItem.address,
    note: leadItem.note,
    status: leadItem.status,
  }
  const [formData, setFormData] = useState(defaultState)
  if (!['admin', 'manager'].includes(user.userType)) {
    return (
      <div className="UpdateLead">
        <h1 className='text-center'>You are not authorized to view this form!</h1>
      </div>
    )
  }

  const handleSubmit = async (evt) =>{
      evt.preventDefault();
      try{
        const data = {...formData}
        // console.log(data)
        await updateLead(leadItem._id, data)
        await toggleNotifications('success', `Lead "${capitalizeFirstLetter(leadItem.leadName)}" Updated!`, '#FFFFFF')
        formNotificationStyle2(`leadUpdateNotification${leadItem._id}`, 'Lead Updated!', '#0A7637', '1')
        await getLeads()
      }catch (err) {
        await toggleNotifications('error', `Failed to Update Lead "${capitalizeFirstLetter(leadItem.leadName)}"!`, '#FFFFFF')
        formNotificationStyle2(`leadUpdateNotification${leadItem._id}`, 'Failed to Update Lead!', '#CA150C', '1')
        console.log(err)
      }
  }

  function handleChange(evt) {
    if (evt.target.name === 'canada' && evt.target.value === 'n') {
      const newFormData = {
        ...formData,
        [evt.target.name]: evt.target.value,
        province: '',
      };
      setFormData(newFormData);
    } else {
      const newFormData = {
        ...formData,
        [evt.target.name]: evt.target.value,
      };
      setFormData(newFormData);
    }
  }

  const disabled = !formData.leadName || !formData.email

  return (
    <div className='UpdateLead modal fade' id={`updateLeadModal${leadItem._id}`}  data-bs-keyboard="true">
      <div className="modal-dialog">
        <div className="modal-content formContainer">
          <div className='header'>
            <div className='left'>
              <div className='first'>
                <svg width="30" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" opacity='0.8'>
                  <path d="M1.6665 14.1666L9.99984 18.3333L18.3332 14.1666M1.6665 9.99996L9.99984 14.1666L18.3332 9.99996M9.99984 1.66663L1.6665 5.83329L9.99984 9.99996L18.3332 5.83329L9.99984 1.66663Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>                    
                </svg>
              </div>
              <div className='second'>
                <div className='sec1'>
                  Update 
                  <span className='primaryText ps-1'>{capitalizeFirstLetter(leadItem.leadName)}</span>
                </div>
              </div>
            </div>
            <div className='right'>
              <svg data-bs-dismiss="modal" width="25" viewBox="0 0 33 33" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="16.2666" cy="16.2666" r="15.7666" fill="#EDEFF2" stroke="#EEEEEE"/>
                <path d="M21.1093 12L12 21.1093M12 12L21.1093 21.1093" stroke="#1B2B41" strokeOpacity="0.8" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </div>
          </div>
          <form onSubmit={handleSubmit} id={`updateLeadForm${leadItem._id}`}>
            <div className='formContent'>
              <div className='name mb-3'>
                <label htmlFor="leadName">Name <span className='requiredField'><strong>*</strong></span></label>
                <input className='form-control' title='Lead Name' type="text" name="leadName" id="leadName" placeholder="Enter Lead's Name" value={formData.leadName} onChange={handleChange} required autoComplete='off'/>
              </div>
              <div className='email mb-3'>
                <label htmlFor="email">Email <span className='requiredField'><strong>*</strong></span></label>
                <input className='form-control' title='Email' type="text" name="email" id="email"  placeholder='Enter Email Address' value={formData.email} onChange={handleChange} required autoComplete='off'/>
              </div>
              <div className='status mb-3'>
                <label htmlFor={`status ${leadItem._id}`}>Status</label>
                <select className='form-select' title='Lead Status' name="status" id={`status ${leadItem._id}`} value={formData.status} onChange={handleChange}>
                  {leadStatusOptions.map((statusItem, index) => (
                    <option key={index} value={statusItem}>{statusItem}</option>
                  ))}
                </select>
              </div>
              <div className='phone mb-3'>
                <label htmlFor="phone">Phone</label>
                <input className='form-control' title='Contact Phone' type="tel" name="phone" id="phone" placeholder="Enter Contact Phone" value={formData.phone} onChange={handleChange} autoComplete='off'/>
              </div>
              <div className='source mb-3'>
                <label htmlFor="source">Source</label>
                <select className='form-select' title='Lead Source' name="source" id="source" value={formData.source} onChange={handleChange}>
                  <option value='' disabled>--- Select Source ---</option>
                  {sourceOptions.map((sourceItem, index) => (
                    <option key={index} value={sourceItem}>{capitalizeFirstLetter(sourceItem)}</option>
                  ))}
                </select>
              </div>
              <div className='contactName mb-3'>
                <label htmlFor="contactName">Contact Name</label>
                <input className='form-control' title='Contact Name' type="text" name="contactName" id="contactName" placeholder="Enter Contact Name" value={formData.contactName} onChange={handleChange} autoComplete='off'/>
              </div>
              <div className='canada mb-3'>
                <div>Lead located in Canada?</div>
                <div className='form-check form-check-inline'>
                  <label className='form-check-label' htmlFor="canadaY">Yes</label>
                  <input className='form-check-input' type="checkbox" name="canada" id="canadaY" value="y" checked={formData.canada === 'y'} onChange={handleChange}/>
                </div>
                <div className='form-check form-check-inline'>
                  <label className='form-check-label' htmlFor="canadaN">No</label>
                  <input className='form-check-input' type="checkbox" name="canada" id="canadaN" value="n" checked={formData.canada === 'n'} onChange={handleChange}/>
                </div>
              </div>
              { formData.canada === 'y' &&
              <div className='province mb-3'>
                <label htmlFor="province">Province</label>
                <select className='form-select' title='Province' name="province" id="province" value={formData.province} onChange={handleChange}>
                  <option value='' disabled>Select</option>
                  {provinceOptions.map((provinceItem, index) => (
                    <option key={index} value={provinceItem.value}>{provinceItem.name}</option>
                  ))}
                </select>
              </div>
              }
              <div className='address mb-2'>
                <label htmlFor="address">Address</label>
                <input className='form-control' title='Address' name="address" id="address" placeholder={`${formData.canada==='y'? "Enter Street Address": "Enter Full Address"}`} value={formData.address} onChange={handleChange} autoComplete='off'/>
              </div>
              <div className='note mt-4'>
                <label htmlFor="note">Note</label>
                <textarea className='form-control' title='Notes' rows={7} name="note" id="note" placeholder="Enter Note" value={formData.note} onChange={handleChange} autoComplete='off'/>
              </div>
            </div>
          </form>
          <div id={`leadUpdateNotification${leadItem._id}`}className='leadUpdateNotification text-center mb-2'></div>
          <div className='d-flex justify-content-center formButtonContainer'>
            <button data-bs-dismiss="modal" className='cancel'>Exit</button>
            <button data-bs-dismiss="modal" className="primary submit" type="submit" form={`updateLeadForm${leadItem._id}`} disabled={disabled}>Save Changes</button>
          </div>
        </div>
      </div>
    </div>
  )
}
